import { InputMask } from '@react-input/mask';
import React from 'react';

import clsxm from '@/lib/clsxm';

import FieldWrapper, {
  FieldWrapperProps,
} from '@/components/forms/field-wrapper';
import { phoneFormValidator } from '@/components/forms/form-validators';

import COMMON_CLASS_NAMES from '@/constants/common-class-names';

export type FormPhoneProps = FieldWrapperProps & {
  placeholder?: string;
};

export default function FormPhone({
  placeholder,
  ...props
}: FormPhoneProps): JSX.Element {
  return (
    <FieldWrapper {...props} pattern={phoneFormValidator}>
      {({ hasError, ...inputProps }) => (
        <InputMask
          mask='(___) ___-____'
          replacement={{ _: /\d/ }}
          className={clsxm(
            COMMON_CLASS_NAMES.input,
            hasError && COMMON_CLASS_NAMES.inputError
          )}
          type='text'
          placeholder={placeholder}
          data-testid='form-phone'
          {...inputProps}
        />
      )}
    </FieldWrapper>
  );
}
